import { isEmpty, isValidNumber } from '../../common/utils/ValidationUtils';
import { COUNTRIES } from './AppConstants';
import { CalculatorValidationParameter } from '../loan/common/types/types';

export const ERROR_PASSWORD_INCORRECT = 'Contraseña incorrecta';
export const ERROR_EMAIL_INCORRECT = 'usuario no existe';
export const ERROR_EMAIL_OR_PASSWORD_INCORRECT = 'Usuario o contraseña incorrecta';
export const ERROR_OLD_PASSWORD_INCORRECT = 'Contraseña actual incorrecta';
export const ERROR_USERNAME_ALREADY_EXIST = 'Ya existe una cuenta con este correo.';
export const ERROR_EMAIL_FORMAT = 'email incorrecto';
export const ERROR_NUMBER_FORMAT = 'solo números';
export const ERROR_PHONE = 'Debe ingresar un teléfono válido';
export const ERROR_ID_FORMAT = 'Debe ingresar un número de identificación válido';
export const ERROR_PARTNER_AND_CLIENT_ID_EQUALS = 'Cédula igual al solicitante';
export const ERROR_REQUIRED = 'campo requerido';
export const FIELD_UPLOAD_REQUIRED = 'Sube el archivo';
export const ERROR_MIN_LENGTH = length => `mínimo ${length} caracteres`;
export const ERROR_MAX_LENGTH = length => `máximo ${length} caracteres`;
export const ERROR_MIN_AGE = age => `Debe tener mas de ${age} años`;
export const ERROR_MAX_DATE = 'Fecha máxima: ';
export const ERROR_DATE_MUST_BE_GREATER_THAN = 'Debe ser mayor a la de inicio';
export const ERROR_POSTAL_CODE_REQUIRED = 'Código postal requerido';
export const ERROR_POSTAL_CODE = 'Código postal inválido';
export const ERROR_EQUIFAX_REQUIRED = 'Debe aceptar los términos y condiciones';
export const ERROR_TERMS_MX_REQUIRED = 'Debe aceptar los términos de privacidad';
export const ERROR_REGISTER_TERMS_REQUIRED = 'Debes aceptar los términos y condiciones';
export const SUCCESS_MESSAGE_FORGET_PASSWORD = 'Enviamos las instrucciones para restablecer tu contraseña a ';
export const ERROR_MUST_CHOOSE_INSURANCE = 'Debe seleccionar un seguro';
export const ERROR_REPEATED_REFERENCE = 'Existen referencias duplicadas';
export const ERROR_FILL_REQUIRED_FIELDS = 'Primero complete los campos requeridos';
export const ERROR_SELECT_AN_ANSWER = 'Selecciona una respuesta';
export const ERROR_SELECT_GROUP_FOR_MIGRATION = 'Selecciona el grupo a migrar';
export const ERROR_VALUE_GT_ZERO = 'Debe ingresar valor mayor a O';
export const ERROR_REQUIRED_NIP = 'Ingresa el código de validación';
export const NIP_CHARACTERS = 6;
export const ERROR_PRICE = getPriceErrorMessage;
export const ERROR_DOWN_PAYMENT = getDownPaymentErrorMessage;
export const ERROR_CANT_PAYMENT_EXCEPTION = 'No se puede solicitar excepción de pago luego de 15 días de la fecha de desembolso';
export const ERROR_ONLY_ONE_CLOSING_BANK_ACTIVE = 'Solo puede existir una financiera de cierre aprobada por solicitud'

interface CurrencyMessageFormater {
    message: string
    currencyValue: number
    country: string
    currencySymbol: string
}

export function getMinValueAllowedErrorMessage(value) {
    return `Debe ingresar un valor mayor que ${value}`;
}

const formatCuerrencyMessage = (data: CurrencyMessageFormater): string => {
    const { message, currencyValue, country, currencySymbol } = data;

    return `${message} ${currencySymbol}${new Intl.NumberFormat(COUNTRIES[country].locale, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }).format(currencyValue)}`;
};

export function getPriceErrorMessage(price, minPrice, country = 'EC', currencySymbol = '$') {
    if (isEmpty(price)) {
        return ERROR_REQUIRED;
    }
    if (isValidNumber(price)) {
        return ERROR_NUMBER_FORMAT;
    }
    if (price < minPrice) {
        const data: CurrencyMessageFormater = {
            country,
            currencySymbol,
            message: 'mínimo',
            currencyValue: minPrice,
        };
        return formatCuerrencyMessage(data);
    }
    return null;
}

export function getDownPaymentErrorMessage(calculator: CalculatorValidationParameter) {
    const {
        vehiclePrice, downPayment, minDownPayment, maxDownPayment, country,
        currencySymbol, maxFinancingAmount, checkFinancingAmount, minFinancingAmount
    } = calculator;

    const data: CurrencyMessageFormater = {
        country: country ? country : 'EC',
        currencySymbol: currencySymbol ? currencySymbol : '$',
        message: 'mínimo',
        currencyValue: null,
    };

    if (isEmpty(downPayment)) {
        return ERROR_REQUIRED;
    }
    if (isValidNumber(downPayment)) {
        return ERROR_NUMBER_FORMAT;
    }
    if (isEmpty(vehiclePrice)) {
        return null;
    }
    if (downPayment < vehiclePrice * minDownPayment) {
        data.currencyValue = vehiclePrice * minDownPayment;
        return formatCuerrencyMessage(data);
    }
    if (downPayment > vehiclePrice * maxDownPayment) {
        data.message = 'máximo';
        data.currencyValue = vehiclePrice * maxDownPayment;
        return formatCuerrencyMessage(data);
    }

    if (checkFinancingAmount) {
        if ((vehiclePrice - downPayment) > maxFinancingAmount) {
            data.message = 'máximo a financiar';
            data.currencyValue = maxFinancingAmount;
            return formatCuerrencyMessage(data);
        }
        if ((vehiclePrice - downPayment) < minFinancingAmount) {
            data.message = 'mínimo a financiar';
            data.currencyValue = minFinancingAmount;
            return formatCuerrencyMessage(data);
        }
    }
    return null;
}
